// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1jPUP","emptyText":"Table_emptyText__14Plc","totalItems":"Table_totalItems__Xv2zc"};